export const AnalyticsModule = {
  state: {
    dateRange: {
      start: new Date(new Date().toISOString().split("T")[0]),
      end: new Date(new Date().toISOString().split("T")[0])
    }
  },

  mutations: {
    SET_DATE_RANGE(state, payload) {
      state.dateRange = payload;
    }
  },

  getters: {
    getDateRange(state) {
      return state.dateRange;
    }
  }
};
